import { keepPreviousData, useQuery } from '@tanstack/react-query'

import { searchBankTransfers } from '@src/api'
import { DefaultApiSearchBankTransfersRequest } from '@src/api/generated/user-api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'

export const useFetchSearchBankTransfers = (
  params: DefaultApiSearchBankTransfersRequest
) => {
  const { axiosInstance } = useAxios()
  return useQuery({
    enabled: !!params.organizationId,
    queryFn: () => searchBankTransfers(axiosInstance, params),
    queryKey: [REACT_QUERY_CACHE_KEYS.GET_SEARCH_BANK_TRANSFERS, params],
    placeholderData: keepPreviousData,
  })
}
